import axios from "axios";
import {
  MdmUserCreateRequest,
  MdmUserEditForm,
  MdmUserEditRequest,
  MdmUserNameRequest,
  MdmUserSearchRequest,
} from "./MdmUserForm";
import { AxiosResponse } from "axios";
import { MdmUser } from "../../../entity/MdmUser";
import { ApplicationApi, ApplicationProtectedRouting } from "../../../Routing";
import { Utility } from "../../../utils/Utility";

/**
 * ユーザー管理 API
 */
export class MdmUserService {

  // ユーザー名一覧取得API
  findMdmUserNameList = async (
    param: MdmUserNameRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationApi.mdmUserName.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報新規作成確認API
  createConfirm = async (param: MdmUserEditForm): Promise<AxiosResponse> => {
    try {
      let request = new MdmUserCreateRequest();
      if (param.expireDateView !== null) {
        let expireDate = Utility.registDateFormat(
          param.expireDateView.toLocaleString()
        );
        param.expireDate = expireDate || "";
      }
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.mdmUserCreateConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報新規作成API
  create = async (param: MdmUserEditForm): Promise<AxiosResponse> => {
    try {
      let request = new MdmUserCreateRequest();
      if (param.expireDateView !== null) {
        let expireDate = Utility.registDateFormat(
          param.expireDateView.toLocaleString()
        );
        param.expireDate = expireDate;
      }
      request.createdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.mdmUserCreateExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報編集取得API
  findByEditId = async (userId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.get(
        ApplicationApi.mdmUserDetail.apiUrl(userId)
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報編集確認API
  updateConfirm = async (param: MdmUserEditForm): Promise<AxiosResponse> => {
    try {
      let request = new MdmUserEditRequest();
      if (param.expireDateView !== null) {
        let expireDate = Utility.registDateFormat(
          param.expireDateView.toLocaleString()
        );
        param.expireDate = expireDate;
      } else {
        param.expireDate = "";
      }
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.mdmUserEditConfirm.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報編集API
  update = async (param: MdmUserEditForm): Promise<AxiosResponse> => {
    try {
      let request = new MdmUserEditRequest();
      if (param.expireDateView !== null) {
        let expireDate = Utility.registDateFormat(
          param.expireDateView.toLocaleString()
        );
        param.expireDate = expireDate;
      }
      request.editdata = param;

      const res: AxiosResponse = await axios.post(
        ApplicationApi.mdmUserEditExecute.apiUrl(),
        request
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー情報削除API
  delete = async (userId: string): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(ApplicationApi.mdmUserDeleteExecute.apiUrl(), {
        userId,
      });
      return res;
    } catch (err) {
      throw err;
    }
  };

  // ユーザー一覧取得API
  findByConditions = async (
    param: MdmUserSearchRequest
  ): Promise<AxiosResponse> => {
    try {
      const res: AxiosResponse = await axios.post(
        ApplicationProtectedRouting.mdmUser.apiUrl(),
        param
      );
      return res;
    } catch (err) {
      throw err;
    }
  };

}
